/**
 * @generated SignedSource<<e81b5781c89151a8cfe19e46250caf64>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HpSharedTrendingNowCarouselTabs_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"HpSharedBestsellingDesignsCarousel_viewer" | "HpSharedExcellentValuesCarousel_viewer" | "HpSharedMostSavedItemsCarousel_viewer">;
  readonly " $fragmentType": "HpSharedTrendingNowCarouselTabs_viewer";
};
export type HpSharedTrendingNowCarouselTabs_viewer$key = {
  readonly " $data"?: HpSharedTrendingNowCarouselTabs_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"HpSharedTrendingNowCarouselTabs_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HpSharedTrendingNowCarouselTabs_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "HpSharedMostSavedItemsCarousel_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "HpSharedExcellentValuesCarousel_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "HpSharedBestsellingDesignsCarousel_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "5bc1bcb055553791a09897393a655a96";

export default node;
